import axios from "axios";

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "https://code-api.iotdong.com",
  // baseURL: process.env.VUE_APP_BASE_API || "https://apis.cong968.cn",
  timeout: 10000,
});

// 全局成功状态码（根据实际后端约定修改，常见值 0 或 200）
const SUCCESS_CODE = 200;  // 若后端成功时返回 code=200，请改为 200

// 需要跳过业务码校验的接口 URL（可选，用于某些特殊接口）
const SKIP_CODE_CHECK_URLS = [
  // '/api/printingQuery', // 如需跳过，取消注释并填写实际路径
];

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 可在此添加 token
    return config;
  },
  (error) => {
    console.error("请求错误：", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const url = response.config.url;

    // 检查是否需要跳过业务码校验（白名单机制）
    const shouldSkipCodeCheck = SKIP_CODE_CHECK_URLS.some(path => url.includes(path));
    if (!shouldSkipCodeCheck && res.code !== undefined && res.code !== SUCCESS_CODE) {
      // 业务失败，统一处理
      console.error(res.msg || "接口错误");
      return Promise.reject(new Error(res.msg || "Error"));
    }

    // 成功时直接返回数据（此时可能没有 code 字段或 code 等于 SUCCESS_CODE）
    return res;
  },
  (error) => {
    console.error("响应错误：", error);
    // 可统一处理 401 等
    return Promise.reject(error);
  }
);

/**
 * 通用请求函数
 * @param {string|object} api - 接口路径或 axios 配置对象
 * @param {object} data - 请求参数（GET 时为 params，POST 时为 data）
 * @param {string} method - 请求方法，默认 post
 * @returns {Promise}
 */
function request(api, data = {}, method = "post") {
  if (typeof api === "object") {
    return service(api);
  }

  const config = {
    url: api,
    method: method.toLowerCase(),
  };
  if (config.method === "get") {
    config.params = data;
  } else {
    config.data = data;
  }
  return service(config);
}

export default request;